import * as React from 'react';
import styles from './Client.module.scss';
import { useRef, useState, useEffect, useContext } from 'react';
import { axiosBackend } from '../../axios/Axios.js';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Resps from './resps/Resps'
import Relatorios from "./relatorios/Relatorios"
import { getToken } from "../../services/auth";
import Contratos from "./contratos/Contratos"
import dayjs, { Dayjs } from 'dayjs';
import { IconEdit } from '../../assets/iconEdit';
import ModalLogo from "./modalLogo/Modal"
import ModalClient from "./modalClient/Modal"
import "./Client.css"

function DadosGerais(props) {
  const client = props.client
  const datestr = props.startstr

  const [isModalLogoOpen, setModalLogoOpen] = useState(false);
  const [isModalClientOpen, setModalClientOpen] = useState(false);

  const [formData, setFormData] = useState({});

  return(
    <div className={styles.component}>
      <ModalLogo handleReload={props.handleReload} uuid={props.uuid} isOpen={isModalLogoOpen} onClose={() =>{setModalLogoOpen(false)}}/>
      {formData !== {} && <ModalClient handleReload={props.handleReload} formData={formData} setFormData={setFormData} isOpen={isModalClientOpen} onClose={() =>{setModalClientOpen(false);}}/>}
      <div className={styles.button_div}>
      </div>
      <div className={styles.dados_box}>
        <button className={styles.button_edit_client} onClick={() =>{setFormData({ ...client, start: dayjs.unix(client.start) }); setModalClientOpen(true)}}>Editar</button>
        <div className={styles.info_flex_row}>
          <div className={styles.info_flex_column_image}>
            <img className={styles.info_flex_column_image_logo} src={client.logo_url}>
            </img>
            <button className={styles.button_change_image} onClick={() =>{setModalLogoOpen(true)}}> <IconEdit size={24}/></button>
          </div>
          <div className={styles.info_flex_column_content}>
              <div className={styles.info_flex_row_content}>
                <div className={styles.info_flex_column_content_item}>
                  <div className={styles.info_flex_column_content_item_title}>Nome do cliente</div>
                  <div className={styles.info_flex_column_content_item_value}>{client.name}</div>
                </div>
                <div className={styles.info_flex_column_content_item}>
                  <div className={styles.info_flex_column_content_item_title}>Keyword</div>
                  <div className={styles.info_flex_column_content_item_value}>{client.key}</div>
                </div>
                <div className={styles.info_flex_column_content_item}>
                  <div className={styles.info_flex_column_content_item_title}>Cliente desde</div>
                  <div className={styles.info_flex_column_content_item_value}>{datestr}</div>
                </div>
              </div>
              <div className={styles.info_flex_column_escope}>
                  <div className={styles.info_flex_column_content_item_title}>Escopo</div>
                  <div className={styles.info_flex_column_escope_value}>{client.escope}</div>
              </div>
            </div>
        </div>
      </div>
    </div>
  )
}

function ClientContent(props) {
  const [dadosPage, setDadosPage] = React.useState(0);
  const CLIENTS_URL = "/clients"
  const [errMsg, setErrMsg] = useState('');
  const [loading, setLoading] = useState(true);
  const [client, setClient] = useState([]);
  const [datestr, setDatestr] = useState("14/03/1998");
  const [startDateObj, setStartDateObj] = useState(dayjs())

  const config = {
    params: {
      "uuid": props.uuid
    },
    headers: {
      "Content-Type": "application/json",
      "Authorization": `Bearer ${getToken()}`
    },
  }

  const handleReload = async () => {
    setLoading(true);

    axiosBackend.get(CLIENTS_URL, config)
      .then(res => {
        setClient(res.data);
        setLoading(false);
        const date = new Date(parseInt(res.data.start) * 1000); // Multiplique por 1000 se o timestamp for em segundos
        setStartDateObj(dayjs.unix(res.data.start));
        setDatestr((String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear()))
      })
      .catch(err => {
        setErrMsg(err.message);
        setLoading(false);
      });
  };


  useEffect(() => {
    setLoading(true);

    axiosBackend.get(CLIENTS_URL, config)
      .then(res => {
        setClient(res.data);
        setLoading(false);
        const date = new Date(parseInt(res.data.start) * 1000); // Multiplique por 1000 se o timestamp for em segundos
        setStartDateObj(dayjs.unix(res.data.start));
        setDatestr((String(date.getDate()).padStart(2, '0') + '/' + String(date.getMonth() + 1).padStart(2, '0') + '/' + date.getFullYear()))
      })
      .catch(err => {
        setErrMsg(err.message);
        setLoading(false);
      });
  }, [props.uuid]);

  const renderComponentBasedOnPage = (dadosPage) => {
    switch(dadosPage) {
      case 0:
        return <DadosGerais handleReload={handleReload} uuid={props.uuid} client={client} startstr={datestr}/>;
      case 1:
        return <Contratos uuid={props.uuid} client={client} startstr={datestr} startDateObj={startDateObj}/>;
      case 2:
        return <Resps uuid={props.uuid}/>;
      default:
        return <div>Conteúdo Padrão</div>;
    }
  };

  const handlePageChange = (event: React.SyntheticEvent, newPage: number) => {
    setDadosPage(newPage);
  };

  return (
    <div className={styles.group}>
      <div className={styles.flex_col}>
        <div className={styles.flex_row}>
          <h1 className={styles.title}>Dados Gerais</h1>
        </div>
        <div className={styles.data_1}>
          <Tabs value={dadosPage} onChange={handlePageChange}>
            <Tab label="Informações do cliente" />
            <Tab label="Contratos" />
            <Tab label="Responsáveis" />
          </Tabs>
          <div className={styles.box_data_1}>
            {renderComponentBasedOnPage(dadosPage)}
          </div>
        </div>
        <Relatorios uuid={props.uuid}/>
      </div>
    </div>
);
}

export default ClientContent;